const IconNames = {
  DASHBOARD_20: 'dashboard_20',
  TSHIRT_20: 'tshirt_20',
  SETTINGS_20: 'settings_20',
  VECTOR_20: 'vector_20',
  FILE_CHART_20: 'file-chart_20',
  FILE_CHART: 'file-chart',
  TIME_20: 'time_20',
  CROSS_20: 'cross_20',
  MONITOR_CELLPHONE_22: 'monitor_cellphone_24',
  LOCK_40: 'lock_40',
  LOCK_28: 'lock_28',
  LOCK_24: 'lock_24',
  USER_24: 'user_24',
  TRI_LOCK: 'tri-lock',
  COLORED_KEY: 'key_icon_colored',
  CHEVRON_DOWN_16: 'chevron_down_16',
  ARROW_LEFT_20: 'arrow_left_20',
  CALENDER_20: 'calendar_20',
  CALENDER_18: 'calendar_18',
  EMAIL_24: 'email_24',
  BELL_DASHBOARD_24: 'bell_dashboard',
  FEEDBACK_24: 'feedback',
  HELP_AND_SUPPORT_24: 'help_and_support',
  HEADER_LOGO: 'echosys_logo',
  ACMS_MODULE: 'acms',
  DATA_ENTRY_120: 'data_entry_120',
  FILE_CHART_120: 'file_chart_120',
  PIE_CHART_120: 'pie_chart_120',
  DOWN_ARROW: 'down_arrow',
  EDIT: 'edit',
  EDIT_18: 'edit_18',
  SEARCH_ICON: 'search_20',
  DELETE: 'delete',
  SECURE_ACCESS: 'secure_access',
  CHECK_18: 'check_18',
  LIST_24: 'list_24',
  CROSS_14: 'cross_14',
  NO_ITEMS: 'no_items',
  CHECKED_ICON: 'checked_icon',
  DETAILS_20: 'details_20',
  ID_CARD: 'id_card',
  MOBILE: 'mobile',
  EMAIL: 'email',
  CHECK_FILLED: 'check_filled',
  ACTIVE_CIRCLE: 'active_circle',
  INACTIVE_CIRCLE: 'inactive_circle',
  LINK: 'link',
  PUBLISH: 'publish',
};

export { IconNames };
